module.exports = __webpack_public_path__ + "static/media/search-header-default.c1ee32a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/search-header-default.svg
// module id = 1219
// module chunks = 0